const PlannerSettings = () => {
  return (
    <div>Timer</div>
  );
}

export default PlannerSettings;